var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgExpired(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B0A8F0",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.411a1.602 1.602 0 00-.456-1.121 1.554 1.554 0 00-1.103-.463H12.558a1.54 1.54 0 00-1.158.434 1.59 1.59 0 00-.487 1.153 1.612 1.612 0 00.487 1.152 1.559 1.559 0 001.158.434H27.45c.412-.003.807-.171 1.098-.469.29-.298.453-.7.452-1.12zM29 10.584a1.603 1.603 0 00-.453-1.118A1.553 1.553 0 0027.45 9H12.559c-.4.021-.776.198-1.052.493-.275.295-.429.686-.429 1.093 0 .407.154.798.43 1.093.275.296.651.472 1.05.493H27.45c.412-.002.807-.17 1.097-.468.29-.298.453-.7.452-1.12z",
    fill: "#AA80FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.944 26.019l-5.49-5.58a.644.644 0 00-.909 0l-5.489 5.58a.655.655 0 00.433 1.109h11a.648.648 0 00.59-.4.66.66 0 00-.135-.71z",
    fill: "#FFB266"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 12.828H14.51a.634.634 0 00-.572.41.66.66 0 00.14.699l5.467 5.583a.643.643 0 00.91 0l5.489-5.583a.654.654 0 00.135-.708.634.634 0 00-.59-.4z",
    fill: "#DFEEF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 12.828H20v6.882a.652.652 0 00.454-.19l5.49-5.583a.654.654 0 00.135-.708.634.634 0 00-.59-.4z",
    fill: "#CCE2F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.454 20.44a.638.638 0 00-.454-.189v6.877h5.49a.634.634 0 00.59-.4.66.66 0 00-.136-.709l-5.49-5.579z",
    fill: "#F29D61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.584a1.603 1.603 0 00-.452-1.118A1.552 1.552 0 0027.45 9H20v3.172h7.45c.413-.002.808-.17 1.098-.468.29-.298.453-.7.452-1.12zM27.45 27.827H20V31h7.45a1.54 1.54 0 001.158-.434 1.59 1.59 0 00.487-1.152 1.612 1.612 0 00-.487-1.153 1.557 1.557 0 00-1.158-.434z",
    fill: "#9167E6"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 9)",
    d: "M0 0h18v22H0z"
  })))));
}
export default SvgExpired;